// More info: https://develop.battle.net/documentation/guides/regionality-and-apis

const regions = ["us", "eu", "kr", "tw"];

const locales = {
  us: "en_US",
  eu: "en_GB",
  kr: "ko_KR",
  tw: "zh_TW"
};

export { regions, locales };
